import { render } from "./Subpage.vue?vue&type=template&id=20649a46&scoped=true"
import script from "./Subpage.vue?vue&type=script&lang=js"
export * from "./Subpage.vue?vue&type=script&lang=js"

import "./Subpage.vue?vue&type=style&index=0&id=20649a46&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20649a46"]])

export default __exports__